// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__Us2kz","btn":"ErrorPage_btn__O9S-D"};